import React from 'react';

const Home_Top_reports = () => {
  return (
    <div style={{ backgroundColor: '#f0f0f0', minHeight: '200px' }}>
          <div className="container d-flex justify-content-center align-items-center">
      <div className="text-center mt-4">
        <h1>Travel report</h1>
        <span>Explore insights and statistics about our travel destination</span>
      </div>
    </div>
    </div>
  
  );
};

export default Home_Top_reports;
